import { z } from 'zod';

const xy = z.object({ x: z.number(), y: z.number() });

export const cartographyNodeDtoSchema = z.object({
  id: z.string().uuid(),
  type: z.enum(['groupNode', 'processNode']),
  position: xy,
  parentId: z.string().uuid().nullable(),
  width: z.number().int(),
  height: z.number().int(),
  draggable: z.boolean(),
  data: z.object({
    label: z.string(),
    color: z.string().optional(),
    groupProcessId: z.string().uuid().optional(),
    processId: z.string().uuid().optional(),
    structureLinkId: z.string().uuid(),
    isEditMode: z.boolean().optional(),
  }),
});

export const cartographyEdgeDtoSchema = z.object({
  id: z.string().uuid(),
  source: z.string().uuid(),
  target: z.string().uuid(),
  sourceHandle: z.string().nullable().optional(),
  targetHandle: z.string().nullable().optional(),
  type: z.string().nullable().optional(),
  animated: z.boolean().optional(),
});

export const cartographyResponseSchema = z.object({
  nodes: z.array(cartographyNodeDtoSchema),
  edges: z.array(cartographyEdgeDtoSchema),
});

export const createGroupStructureLinkSchema = z.object({
  groupProcessId: z.string().uuid(),
  positionX: z.number().int(),
  positionY: z.number().int(),
  width: z.number().int().min(40),
  height: z.number().int().min(40),
});

export const createProcessStructureLinkSchema = z.object({
  processId: z.string().uuid(),
  positionX: z.number().int(),
  positionY: z.number().int(),
  width: z.number().int().min(40),
  height: z.number().int().min(40),
});

export const updateStructureLinkGeometrySchema = z.object({
  positionX: z.number().int(),
  positionY: z.number().int(),
  width: z.number().int().min(40),
  height: z.number().int().min(40),
});

export const bulkUpdateStructureLinksSchema = z.object({
  updates: z.array(
    z.object({
      structureLinkId: z.string().uuid(),
      positionX: z.number().int(),
      positionY: z.number().int(),
      width: z.number().int().min(40),
      height: z.number().int().min(40),
    }),
  ),
});

export const replaceSiteEdgesSchema = z.object({
  edges: z.array(
    z.object({
      sourceProcessId: z.string().uuid(),
      targetProcessId: z.string().uuid(),
    }),
  ),
});

export type CartographyNodeDto = z.infer<typeof cartographyNodeDtoSchema>;
export type CartographyEdgeDto = z.infer<typeof cartographyEdgeDtoSchema>;
export type CartographyResponseDto = z.infer<typeof cartographyResponseSchema>;
export type CreateGroupStructureLinkInput = z.infer<typeof createGroupStructureLinkSchema>;
export type CreateProcessStructureLinkInput = z.infer<typeof createProcessStructureLinkSchema>;
export type UpdateStructureLinkGeometryInput = z.infer<typeof updateStructureLinkGeometrySchema>;
export type BulkUpdateStructureLinksInput = z.infer<typeof bulkUpdateStructureLinksSchema>;
export type ReplaceSiteEdgesInput = z.infer<typeof replaceSiteEdgesSchema>;
